var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webFooter"},[_c('span',{staticStyle:{"margin-left":"10%"}},[_vm._v("首页")]),_c('span',[_vm._v("登录")]),_c('span',[_vm._v("注册")]),_c('span',[_vm._v("关于我们")])])
}]

export { render, staticRenderFns }